var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4"},[_c('h1',[_vm._v("carousel")]),_c('CarouselCard',{staticClass:"fill-height"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }